import React from 'react';
import PropTypes from "prop-types";
import Icon from './Icon';
import { formatClassName } from '../Util';

export default class GenericLabel extends React.Component {
  static propTypes = {
    additionalClasses: PropTypes.string,
    allowLineBreaks: PropTypes.bool,
    bordered: PropTypes.bool,
    borderCurve: PropTypes.oneOf(['right', 'left']),
    className: PropTypes.string,
    dataAttributes: PropTypes.shape({
      action: PropTypes.string,
      objectId: PropTypes.string,
      objectType: PropTypes.string,
      componentType: PropTypes.string
    }),
    label: PropTypes.node.isRequired,
    value: PropTypes.node,
    icon: PropTypes.string,
    iconColor: PropTypes.oneOf(['gray', 'red', 'yellow', 'blue', 'green']),
    iconPosition: PropTypes.oneOf(['left', 'right']),
    iconSize: PropTypes.oneOf(['small', 'medium', 'large', 'extralarge']),
    fontWeight: PropTypes.string,
    fontFamily: PropTypes.string,
    type: PropTypes.string
  };

  static defaultProps = {
    allowLineBreaks: false,
    fontFamily: 'zmdi',
    iconColor: 'gray',
    fontWeight: 'normal',
    iconPosition: 'left',
    bordered: false
  }

  getIconClasses = () => {
    const { iconColor, iconPosition, fontWeight, type } = this.props;

    return formatClassName([
      `generic-label-icon`,
      `generic-label-icon-${iconColor}`,
      `generic-label-font-${fontWeight}`,
      `generic-label-${type}`,
      `generic-label-icon-${iconPosition}`
    ])
  }

  renderIcon = position => {
    const { fontFamily, icon, iconSize, iconPosition, additionalClasses } = this.props;
    const iconClasses = this.getIconClasses();
    if (!icon || iconPosition !== position) {
      return null;
    }
    return (
      <div className={iconClasses}>
        <Icon iconType={icon} fontFamily={fontFamily} additionalClasses={additionalClasses} size={iconSize} />
      </div>
    );
  }

  renderLabel = () => {
    const { label, value } = this.props;
    return (
      <>
        {value ? <span className="f-500">{`${label}:`}&nbsp;</span> : label}
        {value}
      </>
    );
  }

  getLabelClasses = () => {
    const { allowLineBreaks, className, label, bordered, borderCurve } = this.props;
    const hasLabel = Boolean(label);
    return formatClassName([
      'generic-label',
      `border-curve-${borderCurve}`,
      { 'has-label': hasLabel },
      { 'bordered': bordered },
      { 'allow-line-breaks': allowLineBreaks },
      className
    ])
  }

  getDataAttributes = () => {
    const { dataAttributes } = this.props;
    const dataProps = {};
    if (dataAttributes?.action) {
      dataProps['data-action'] = dataAttributes.action;
    }
    if (dataAttributes?.objectId) {
      dataProps['data-object-id'] = dataAttributes.objectId;
    }
    if (dataAttributes?.objectType) {
      dataProps['data-object-type'] = dataAttributes.objectType;
    }
    if (dataAttributes?.componentType) {
      dataProps['data-component-type'] = dataAttributes.componentType;
    }
    return dataProps;
  }

  render() {
    return (
      <div className={this.getLabelClasses()} {...this.getDataAttributes()}>
        {this.renderIcon('left')}
        {this.renderLabel()}
        {this.renderIcon('right')}
      </div>
    )
  }
}
